module.exports = __webpack_public_path__ + "img/google-assistant.942e18b7.svg";